import { IconProps } from '@/assets/types/icon'

const XLogo = ({ className, ...props }: IconProps) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M31.9978 16.0006C31.9978 24.0816 26.0078 30.7623 18.2265 31.8464C17.4989 31.9473 16.7545 32 15.9989 32C15.1267 32 14.2702 31.9305 13.4361 31.796C5.81838 30.5695 0 23.9638 0 16.0006C0 7.16393 7.16368 0 16 0C24.8363 0 32 7.16393 32 16.0006H31.9978Z"
        fill="#7D7D7D"
      />
      <path
        d="M6.48881 7.05748L13.8677 16.9233L6.44284 24.9449H8.11437L14.6155 17.9222L19.8677 24.9449H25.555L17.7612 14.5241L24.6727 7.05748H23.0011L17.0146 13.5252L12.1771 7.05748H6.48992H6.48881ZM8.9462 8.28847H11.5583L23.0953 23.7139H20.4832L8.9462 8.28847Z"
        fill="white"
      />
    </svg>
  )
}

export default XLogo
